module.exports = __webpack_public_path__ + "img/sun.d9bcfc6a.svg";